import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { ButtonComponent } from '@mode/capra';
import { DialogHeaderComponent, StatusBannerComponent } from '@mode/shared/ui';
import { Observable, take } from 'rxjs';
import { SharedUtilSegmentModule } from '@mode/shared/util-segment';
import { DatasetFacade } from '@mode/dataset/contract';
import { EnhancedDatasetResult } from '@mode/shared/contract-common';
import { SwitchViewFacade } from '@mode/switch-views/contract';
@Component({
  selector: 'mode-republish-dataset-dialog',
  standalone: true,
  imports: [CommonModule, ButtonComponent, DialogHeaderComponent, StatusBannerComponent, SharedUtilSegmentModule],
  templateUrl: './republish-dataset-dialog.component.html',
  styleUrls: ['./republish-dataset-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepublishDatasetDialogComponent implements OnInit {
  enhancedDatasetResult$!: Observable<EnhancedDatasetResult | undefined>;
  switchViewToken: string;
  @Output() republish = new EventEmitter<{
    datasetThoughtspotPublicationToken: string;
  }>();

  constructor(
    protected dialogRef: MatLegacyDialogRef<RepublishDatasetDialogComponent>,
    private datasetFacade: DatasetFacade,
    private switchViewFacade: SwitchViewFacade,
    @Inject(MAT_LEGACY_DIALOG_DATA)
    private data: {
      switchViewToken: string;
    }
  ) {
    this.switchViewToken = data.switchViewToken;
  }

  ngOnInit(): void {
    this.enhancedDatasetResult$ = this.switchViewFacade.getEnhancedDataseResult(this.switchViewToken);
  }

  republishDataset(): void {
    this.enhancedDatasetResult$.pipe(take(1)).subscribe({
      next: (enhancedDatasetResult) => {
        this.republish.emit({
          datasetThoughtspotPublicationToken:
            enhancedDatasetResult?.thoughtspot?.datasetThoughtspotPublicationToken ?? '',
        });
      },
    });
    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
